import React from 'react';

const GreenProfile = ({}) => {
	return (
		<div className="green-subpage green-profile">
			profile
		</div>
	);
};

export default GreenProfile;
